// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface AdvancedPlatformMetricsListOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface AdvancedPlatformMetricsDeleteOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface AdvancedPlatformMetricsCreateOrUpdateOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface AdvancedPlatformMetricsGetOptionalParams extends OperationOptions {}
